var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2402 1.73706C11.2064 1.42098 10.7936 1.42098 10.7598 1.73706L10.4767 4.3887C10.111 7.81269 7.68142 10.5122 4.59986 10.9185L2.21338 11.2331C1.92887 11.2707 1.92887 11.7293 2.21338 11.7669L4.59986 12.0815C7.68142 12.4878 10.111 15.1873 10.4767 18.6113L10.7598 21.2629C10.7936 21.579 11.2064 21.579 11.2402 21.2629L11.5233 18.6113C11.889 15.1873 14.3186 12.4878 17.4002 12.0815L19.7866 11.7669C20.0711 11.7293 20.0711 11.2707 19.7866 11.2331L17.4002 10.9185C14.3186 10.5122 11.889 7.81269 11.5233 4.3887L11.2402 1.73706Z",
    stroke: "#020808",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStar);
export default __webpack_public_path__ + "static/media/black-star.c9e91ced8a12d73ba83feb94ee2f95ce.svg";
export { ForwardRef as ReactComponent };